import { cn } from '@repo/ui/lib/cn';
import * as React from 'react';

interface PageHeaderProps {
  title: string;
  subtitle?: string;
  actions?: React.ReactNode;
  className?: string;
}

const PageHeader = React.forwardRef<HTMLDivElement, PageHeaderProps>(
  ({ title, subtitle, actions, className }, ref) => {
    return (
      <div
        ref={ref}
        className={cn(
          'flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between',
          className,
        )}
      >
        <div>
          <h1 className="text-foreground text-2xl font-bold">{title}</h1>
          {subtitle && <p className="text-muted-foreground mt-1">{subtitle}</p>}
        </div>
        {actions && <div className="flex shrink-0 gap-2">{actions}</div>}
      </div>
    );
  },
);
PageHeader.displayName = 'PageHeader';

export { PageHeader };
